'use strict';

/**
 * Maps {@link postLocationUpdate} rejections to dealer `#modalBody` copy (same rules as
 * {@link postUpdateLocation} in location-modal-update.js).
 *
 * @param {JQuery} $modalBody
 * @param {unknown} error
 * @returns {string|null}
 */
function getDealerModalPostLocationErrorMessage($modalBody, error) {
	if (!error || typeof error !== 'object' || !('errorCode' in error)) {
		return null;
	}
	const errorCode = error.errorCode;
	if (errorCode === 'request_failed') {
		return $modalBody.data('error-generic');
	}
	const errorMessages = {
		no_shipping_zone: $modalBody.data('error-no-shipping-zone'),
		unsupported_zip: $modalBody.data('error-invalid-zip'),
	};
	let message = errorMessages.unsupported_zip;
	if (typeof errorCode === 'string' && Object.hasOwn(errorMessages, errorCode)) {
		message = errorMessages[errorCode];
	}
	return message;
}

module.exports = { getDealerModalPostLocationErrorMessage };
